module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/d17147f484689977f1ed7e6acbeb994a.png";